import { isNullOrEmptyArray } from "src/util/arrays";

const principal = "principal";
const secondary = "secondary";

function getEquivalency(principalAlt, items = []) {
  const alternatives = [...items];
  
  if (principalAlt) {
    alternatives.splice(alternatives.indexOf(principalAlt), 1);
  }

  return alternatives.map(({ id_alternativa, id_pesquisa, id_pergunta }) => ({
    id: id_alternativa,
    id_pergunta,
    id_pesquisa,
  }));
}

/**
 * @param {array} group
 * @param {string} type "principal" | "secondary"
 */
function getAlternativesModel(
  groupAlternatives = [],
  principalSurveyId,
) {

  const result = [];

  // Parseia um array de alternativas para o modelo final do payload. 
  const alternativesToEquivalency = (array, id_pergunta_correspondente) => {
    if (isNullOrEmptyArray(array)) {
      return;
    }

    const principalAlt = array.find(({ id_pesquisa }) => id_pesquisa === principalSurveyId);
    
    const crossingResult = {
      // id da alternativa principal
      id: null,
      id_pergunta: null,
      alternativas_equivalentes: [],
    };

    if (principalAlt) {
      crossingResult.id = principalAlt.id_alternativa;
      crossingResult.id_pergunta = principalAlt.id_pergunta;
    } else if (id_pergunta_correspondente) {
      crossingResult.id_pergunta = id_pergunta_correspondente;
    }

    crossingResult.alternativas_equivalentes = getEquivalency(principalAlt, array);
    result.push(crossingResult);
  }

  groupAlternatives.forEach(({ matched, avulsas, id_pergunta_correspondente }) => {
    matched.forEach((matchArray) => {
      alternativesToEquivalency(matchArray, id_pergunta_correspondente);
    });

    avulsas.map((alt) => [alt]).forEach((array) => {
      alternativesToEquivalency(array, id_pergunta_correspondente);
    })
  });

  return result;
}

/**
 * Parser para a configuração final feita pelo usuário
 */
export const parseEvolutiveCrossConfig = function (
  surveyId,
  stepOneData = [],
  stepThreeData = []
) {
  const [principalGroup, ...secondaryGroups] = stepThreeData;

  const payload = {
    descricao: "Configuracao evolutivo teste",
    mapeamento_pesquisas: {
      alternativas_principais: getAlternativesModel(
        [principalGroup],
        surveyId,
      ),
      alternativas_cruzadas: getAlternativesModel(
        secondaryGroups,
        surveyId,
      ),
      pesquisa_principal: {
        id: surveyId,
      },
      pesquisas_equivalentes: stepOneData.map(({ id }) => ({ id })),
    },
  };

  return payload;
};
